/* eslint-disable no-param-reassign */
/* @ngInject */

export default (
  $q,
  $state,
  $rootScope,
  $scope,
  webpage,
  accountService,
  eventService,
  helperService,
  changesService,
  uiService,
  jsonFactory,
  AccountUser,
  AccountExchange,
  PersonalTitle,
  GOOGLEMAPS,
  INSTANCE
) => {
  $scope.Model = {
    INSTANCE,
    countries: null,
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');
  $q.all([
    accountService.readAccount({ id: $rootScope.CurrentAccount.id }),
    jsonFactory.getCountries()
  ])
    .then((data) => {
      // Overwrite $rootScope values in case they've reverted to values within Token
      $rootScope.CurrentAccount.user = AccountUser.build(data[0].user);
      $rootScope.CurrentAccount.exchange = AccountExchange.build(data[0].exchange);
      // Set Model values
      const countries = data[1];
      $scope.Model.countries = countries;
    })
    .then(() => {
      // Declare Model as Ready and start rendering the page
      webpage.pageTitle('My account : Settings');
      $scope.Model.isReady = true;
    });

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.next = () => {
    if ($rootScope.CurrentAccount.hasAccountDetails()) {
      if ($rootScope.CurrentAccount.isBroker) {
        $state.transitionTo('settings.my-accreditations');
      } else {
        $state.transitionTo('settings.password-and-security');
      }
    }
  };

  $scope.saveAccount = (data) => {
    if (data?.id) {
      if (!_.isEmpty(data?.user)) {
        $rootScope.CurrentAccount.user = data?.user;
      }
      if (!_.isEmpty(data?.exchange)) {
        $rootScope.CurrentAccount.exchange = data?.exchange;
      }
      changesService.change();
    }
  };

  /*
   * Register and configure Changes service
   * --------------------------------------------------------------------------------
   */
  const saveChanges = () => {
    const accountData = {
      id: $rootScope.CurrentAccount.id,
      user: $rootScope.CurrentAccount.user,
      exchange: $rootScope.CurrentAccount.exchange
    };
    return accountService.updateAccount(accountData).then((result) => {
      if (result.status) {
        if (changesService.hasChange({ group: 'user' })) {
          eventService.credentialsChanged();
        }
        changesService.resetChanges();
      } else {
        uiService.toast({
          text: {
            p1: 'Failed to',
            p2: 'save',
            p3: 'your changes'
          },
          warn: true
        });
      }
      return { status: !!result.status };
    });
  };

  changesService.init({ useFinishOnInterval: true });
  changesService.onFinish(saveChanges);
};
